export default __webpack_public_path__ + "4b397f14cb7261e2f8212063ab03be31.png";